export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contraseña antigua"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva contraseña"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmación de la contraseña"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La \"Nueva contraseña\" y la \"Confirmación de la contraseña\" no coinciden."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cambiar contraseña"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cadena de 4 a 63 caracteres. Se permiten caracteres del alfabeto latino, números y símbolos"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vacío"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Débil"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Medio"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fuerte"])}
  }
}